import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledOnboardingTasks = styled('div')`
  width: 100%;
  display: flex;
  box-sizing: border-box;
  flex: 1;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  height: 100vh;
  background-color: ${COLOR.white};
  overflow-y: scroll;
  gap: 40px;
  .container-onboarding-tasks {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 40px;
  }
`;

export const StyledTasks = styled('div')`
  width: 100%;
  height: 100%;
  padding: ${({ fromPopup }) => (fromPopup ? '0px' : '40px 40px 0 40px')};
  box-sizing: border-box;
  .container-tasks {
    max-width: 660px;
    margin: 0 auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding-bottom: ${({ fromPopup }) => (fromPopup ? '0px' : '40px')};
    box-sizing: border-box;
  }

  .title-onboarding-mobile {
    display: none;
  }

  @media (min-width: 1900px) {
    padding: ${({ fromPopup }) => (fromPopup ? '0px' : '80px 40px 0 40px')};
  }

  @media (max-width: 650px) {
    padding: 0px;
    .title-onboarding {
      display: none;
    }
    .title-onboarding-mobile {
      display: block;
    }
  }
`;

export const StyledTaskList = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: ${({ height }) => (height ? `${height}px` : '100%')};
  gap: 16px;
  overflow-y: ${({ preventScroll }) => !preventScroll && 'scroll'};
  max-height: 100%;
  padding-right: 8px;
  box-sizing: border-box;
  &.hidden-scrollbar {
    &::-webkit-scrollbar {
      width: 4px;
      background: ${COLOR.white};
    }
    &::-webkit-scrollbar-thumb {
      width: 4px;
      background: ${COLOR.white};
    }
    &::-webkit-scrollbar {
      width: 4px;
      background: ${COLOR.white};
    }
  }

  &.small-scrollbar {
    // scrollbar-width: thin;
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      background: ${COLOR.white};
    }
    &::-webkit-scrollbar-thumb {
      background: ${COLOR.indigo[64]};
      border-radius: 2px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: ${COLOR.indigo[80]};
      border-radius: 2px;
    }
  }

  @media (max-width: 650px) {
    padding: 16px;
    padding-bottom: 60px;
  }
`;

export const StyledPanel = styled('div')`
  width: 100%;
  display: flex;
  height: 100%;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  background-color: #ffd60a14;
  justify-content: center;
  overflow: hidden;
  .container {
    display: grid;
    place-items: center;
    width: 100%;
    height: 100%;
    justify-content: center;
    overflow: hidden;
  }

  .hero-circle {
    position: relative;
    width: 1200px;
    height: 100%;
    overflow: hidden;
  }

  .inner-img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80px;
    height: 80px;
    object-fit: cover;
    border-radius: 10px;
  }

  .hero-rotate {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 1px solid #ffd60a;
    border-radius: 50%;
    animation: rotate 30s linear infinite;
  }

  @keyframes rotate {
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }

  @keyframes rotate-reverse {
    100% {
      transform: translate(-50%, -50%) rotate(-360deg);
    }
  }

  .circle-1 {
    width: 400px;
    height: 400px;
    border-color: #ffd60a3d;
  }

  .circle-2 {
    width: 600px;
    height: 600px;
    border-color: #ffd60a7d;
    animation: rotate-reverse 45s linear infinite;
  }

  .circle-3 {
    width: 800px;
    height: 800px;
    border-color: #ffd60a8f;
  }

  .circle-4 {
    width: 1000px;
    height: 1000px;
    border-color: #ffd60a8f;
  }

  .planet {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 40px;
    height: 40px;
    transform-origin: center;
  }

  .planet img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    animation: none;
  }

  .circle-1 .planet img,
  .circle-3 .planet img,
  .circle-4 .planet img {
    animation: planet-upright 30s linear infinite;
  }

  .circle-2 .planet img {
    animation: planet-upright-reverse-cw 45s linear infinite;
  }

  .circle-2 .planet-2-circle2 img {
    animation: planet-upright 45s linear;
  }

  @keyframes planet-upright {
    100% {
      transform: rotate(-360deg);
    }
  }

  @keyframes planet-upright-reverse-cw {
    100% {
      transform: rotate(360deg);
    }
  }

  .planet-1-circle1 {
    transform: rotate(0deg) translateY(181px);
  }
  .planet-2-circle1 {
    transform: rotate(360deg) translateY(-222px);
  }

  .planet-1-circle2 {
    transform: rotate(0deg) translateX(280px);
  }

  .planet-3-circle2 {
    transform: rotate(361deg) translateX(-318px);
  }

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const StyledTasksHeader = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  height: 44px;
  justify-content: space-between;
  margin-bottom: 40px;

  @media (max-width: 650px) {
    display: none;
  }
`;

export const StyledTask = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  height: 72px;
  border-radius: 12px;
  border: 0.5px solid ${COLOR.errorHover};
  padding: 12px;
  justify-content: space-between;
  box-sizing: border-box;
  transition: background-color 0.3s ease;
  background-color: ${({ isCompleted }) =>
    isCompleted ? COLOR.backgroundRecordTime : COLOR.white};
  &:hover {
    background-color: ${COLOR.backgroundRecordTime};
  }

  @media (max-width: 650px) {
    height: auto;
  }
`;

export const StyledTaskCompleted = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  height: 56px;
  border-radius: 12px;
  border: 1px solid ${COLOR.errorHover};
  padding: 12px;
  justify-content: space-between;
  box-sizing: border-box;
  transition: background-color 0.3s ease;
  background-color: ${COLOR.white};

  @media (max-width: 650px) {
    height: auto;
  }
`;

export const StyledTaskContentLeft = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const StyledTaskTitle = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 4px;

  .bonus-credits-mobile {
    display: none;
  }

  @media (max-width: 650px) {
    .title-task {
      font-size: 14px;
    }
    .description-task {
      font-size: 12px;
    }
    .bonus-credits-mobile {
      font-size: 12px;
      display: block;
      strong {
        font-size: 14px !important;
      }
    }
  }
`;

export const StyledTaskContentRight = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;
  @media (max-width: 650px) {
    .bonus-credits {
      display: none;
    }
  }
`;
